import { AnimatePresence, motion } from 'framer-motion'
import { ApiPrice } from 'sprites-types/api/prices'
import { GradientText } from './GradientText'

interface PriceDisplayProps {
  plan: {
    id: string
    stripeProductId: string | null
  }
  prices: Record<string, ApiPrice[]>
  billingInterval: 'month' | 'year'
}

export const PriceDisplay = ({ plan, prices, billingInterval }: PriceDisplayProps) => {
  if (plan.id === 'business') {
    return (
      <GradientText className="my-auto pb-2" size="text-4xl">
        Custom Pricing
      </GradientText>
    )
  }

  if (plan.stripeProductId && prices[plan.stripeProductId]) {
    const currentPrice =
      prices[plan.stripeProductId].find((p) => p.interval === billingInterval) ||
      prices[plan.stripeProductId][0]
    return (
      <div className="flex items-end">
        <AnimatePresence mode="wait">
          <motion.div
            key={`${plan.id}-${billingInterval}-${currentPrice.amount}`}
            initial={{
              opacity: 0,
              y: 15,
            }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -15 }}
            transition={{ duration: 0.5, ease: 'easeOut' }}
            className="flex items-end"
          >
            <GradientText size="text-5xl">${currentPrice.amount / 100}</GradientText>
            <motion.div
              key={`${plan.id}-${billingInterval}-period`}
              initial={{
                opacity: 0,
                x: 15,
              }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 15 }}
              transition={{ duration: 0.3, ease: 'easeOut', delay: 0.1 }}
              className="flex -translate-x-2.5 flex-col font-medium text-white opacity-0"
            >
              <span className="leading-snug">
                /{billingInterval === 'month' ? 'Month' : 'Year'}
              </span>
            </motion.div>
          </motion.div>
        </AnimatePresence>
      </div>
    )
  }

  return (
    <motion.div
      key={`${plan.id}-free`}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.3, ease: 'easeOut' }}
      className="translate-y-5 opacity-0"
    >
      <GradientText size="text-5xl">Free</GradientText>
    </motion.div>
  )
}
